import { render, staticRenderFns } from "./MiraSplitBars.vue?vue&type=template&id=38143dd6&scoped=true&"
import script from "./MiraSplitBars.vue?vue&type=script&lang=ts&"
export * from "./MiraSplitBars.vue?vue&type=script&lang=ts&"
import style0 from "./MiraSplitBars.vue?vue&type=style&index=0&id=38143dd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38143dd6",
  null
  
)

export default component.exports